declare var moment: any;

var allMetricName = "[ALL]";
//function convertObjectToClass<T>(obj: T, cls: new (...args: any[]) => T): T {
//    return Object.assign(new cls(), obj);
//}

//function createInstance<T>(cls: new (data: any) => T, data: any): T {
//    return new cls(data);
//}

/**
 * Create instances of cls (Class name) for the dataArray items
 * @param cls Class Name
 * @param dataArray Array of objects
 * @returns Array of objects converted to the Class
 */
function createInstances<T, U>(cls: new (data: U) => T, dataArray: U[]): T[] {
    if (dataArray && Array.isArray(dataArray)) {
        return dataArray.map(data => new cls(data));
    }
    else {
        return [];
    }
}

function createInstancesWithParameter<T, U, V>(cls: new (data: U, extra: V) => T, dataArray: U[], extra: V): T[] {
    if (dataArray && Array.isArray(dataArray)) {
        return dataArray.map(data => new cls(data, extra));
    }
    else {
        return [];
    }
}

function createInstancesWithParameterFirst<T, U, V>(cls: new (extra: V, data: U) => T, extra: V, dataArray: U[]): T[] {
    if (dataArray && Array.isArray(dataArray)) {
        return dataArray.map(data => new cls(extra, data));
    }
    else {
        return [];
    }
}

function createInstancesWithParams<T, U>(cls: new (data: U, ...params: any[]) => T, dataArray: U[], ...params: any[]): T[] {
    if (dataArray && Array.isArray(dataArray)) {
        return dataArray.map(data => new cls(data, ...params));
    }
    else {
        return [];
    }
}

/**
 * Replace Html comments, &nbsp; and <br> with space
 * @param text  Text to replace
 * @returns     Text with replaced values
 */
function replaceBasicHtmlContent(text: string, replaceComment: boolean = true): string {
    if (!text || typeof text !== "string") {
        return text;
    }

    let newText = text.replaceAll(/&nbsp;/g, " ").replaceAll(/<br\s*\/?>/gi, " ");
    if (replaceComment) {
        newText = newText.replaceAll(/<!--.*?-->/g, "");
    }
    return newText;
 }

function groupingTypeToString(enumValue: GroupingTypeEnum) {
    if (enumValue === GroupingTypeEnum.NONE || !enumValue) {
        return "";
    }
    return GroupingTypeEnum[enumValue];
}

function reportTypeToString(enumValue: ReportTypeEnum) {
    if (enumValue === ReportTypeEnum.Analysis) {
        return "Report";
    }
    return ReportTypeEnum[enumValue];
}

function autoGroupingToString(enumValue: AutoGroupingEnum, withoutBy?: boolean) {
    if (enumValue === AutoGroupingEnum.None || !enumValue) {
        return "";
    }
    let autoGroupingText = AutoGroupingEnum[enumValue];
    if (withoutBy) {
        autoGroupingText = autoGroupingText.replace("By", "");
    }
    return autoGroupingText;
}

function autoGroupingToStringAndSplit(enumValue: AutoGroupingEnum) {
    return splitOnUpper(autoGroupingToString(enumValue));
}

function topBottomToString(enumValue: TopBottomEnum) {
    if (!enumValue) {
        return "All";
    }
    return TopBottomEnum[enumValue];
}

function splitOnUpper(text) {
    let titleCaseString = text
        .replace(/(_)/g, ' ')
        .trim()
        .replace(/\w\S*/g, function (str) {
            return str.charAt(0).toUpperCase() + str.substr(1)
        })
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')

    return titleCaseString;
}

function getAutoGroupingText(value, autoGrouping: AutoGroupingEnum) {
    if (value === null) {
        return irSettings.nullText;
    }

    if (autoGrouping === AutoGroupingEnum.ByYear) {
        return value;
    }

    let dateFormat = irSettings.shortDateFormatForMoment;
    let dateSeparator = irSettings.dateSeparator;
    let weekStartDay = irSettings.weekStartDay;
    let yearMonthStart = irSettings.yearMonthStart;
    let yearOffSet = irSettings.yearOffSet; //Not Implemented yet

    if (weekStartDay === undefined) {
        weekStartDay = 1;
    }

    let year: number;
    let output = "";
    switch (autoGrouping) {
        //Week
        case AutoGroupingEnum.ByWeek:
        case AutoGroupingEnum.ByWeekNumber:
            year = parseInt((value / 100).toString());
            let weekOfYear = parseInt((value - year * 100).toString());

            let displayDateWithDay = autoGrouping === AutoGroupingEnum.ByWeek;
            if (displayDateWithDay) {
                let weekBoundaries = calculateWeekBoundaries(year, weekOfYear, irSettings.weekStartDay, irSettings.yearMonthStart, irSettings.yearOffSet);

                let mIdx = dateFormat.indexOf("M");
                let dIdx = dateFormat.indexOf("D");
                let format = mIdx > dIdx ? `DD${dateSeparator}MM` : `MM${dateSeparator}DD`;
                if (dateFormat.indexOf("MM") === -1) {
                    format = format.replace("DD", "D").replace("MM", "M");
                }
                let weekStart = moment(weekBoundaries.weekStart);
                let weekEnd = moment(weekBoundaries.weekEnd);
                output = `Week ${weekOfYear}, ${year} ${weekStart.format(`${format}`)} - ${weekEnd.format(format)}`;
            }
            else {
                output = `Week ${weekOfYear}, ${year}`;
            }
            break;
        case AutoGroupingEnum.ByWeekOnly:
            output = `Week ${value}`;
            break;
        //Month
        case AutoGroupingEnum.ByMonth:
            {
                let year = parseInt((value / 100).toString());
                let month = parseInt((value - year * 100).toString());

                //Month shouldn't change the calendar year
                //if (yearOffSet && month > yearMonthStart) {
                //    year++;
                //}
                let date = new Date(year, month - 1, 1); //new Date the month is 0-indexed
                output = `${moment(date).format('MMM')} ${date.getFullYear()}`;
                break;
            }
        //Quarter
        case AutoGroupingEnum.ByQuarter:
            {
                let year = parseInt((value / 10).toString());
                let quarter = parseInt((value - year * 10).toString());
                output = `Q${quarter} ${year}`;
                break;
            }
        //MonthOnly
        case AutoGroupingEnum.ByMonthOnly:
            if (irSettings.yearMonthStart > 0) {
                value = value + irSettings.yearMonthStart;
                if (value > 11) {
                    value -= 12;
                }
            }
            output = `${moment(new Date(2000, value - 1, 1)).format('MMMM')}`;
            break;
        //QuarterOnly
        case AutoGroupingEnum.ByQuarterOnly:
            output = `Q${value}`;
            break;
        //None
        case AutoGroupingEnum.None:
        //ByDay
        case AutoGroupingEnum.ByDay:
            output = moment(value).format(dateFormat);
            break;
    }

    return output;
}

function calculateWeekBoundaries(year: number, weekNumber: number, weekStartDay: number, yearStartMonth: number, yearOffSet: boolean) {
    //This function treats Sunday as 0
    weekStartDay--;

    if (yearOffSet) {
        year--;
    }

    const yearFirstDay = new Date(year, yearStartMonth, 1);

    const weekAdjustment = yearFirstDay.getDay() <= weekStartDay ?
          (7 - yearFirstDay.getDay() + weekStartDay) % 7 :
          (-yearFirstDay.getDay() + weekStartDay) % 7;
  
    const firstWeekStart = new Date(yearFirstDay);
    firstWeekStart.setDate(yearFirstDay.getDate() + weekAdjustment);

    const weekStart = new Date(firstWeekStart);
    weekStart.setDate(firstWeekStart.getDate() + (weekNumber - 1) * 7);

    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);

    return {
        weekStart: weekStart,
        weekEnd: weekEnd
    };
}

function getFieldDisplayName(fieldId: number, autoGrouping: AutoGroupingEnum): string {
    if (autoGrouping === AutoGroupingEnum.None) {
        return MappingService.getFieldName(fieldId);
    }

    let field = MappingService.getField(fieldId);
    if (field) {
        return `${field.displayName} ${autoGroupingToString(autoGrouping)}`;
    }

    return "";
}

function widgetTypeToReportType(widgetType: WidgetType): ReportTypeEnum {
    switch (widgetType) {
        case WidgetType.Report:
            return ReportTypeEnum.Analysis;
        case WidgetType.Chart:
            return ReportTypeEnum.Chart;
        case WidgetType.Pivot:
            return ReportTypeEnum.Pivot;
    }
    return null;
}

function reportTypeToWidgetType(reportType: ReportTypeEnum): WidgetType {
    switch (reportType) {
        case ReportTypeEnum.Analysis:
            return WidgetType.Report;
        case ReportTypeEnum.Chart:
            return WidgetType.Chart;
        case ReportTypeEnum.Pivot:
            return WidgetType.Pivot;
    }
    return null;
}

function widgetTypeToTabType(widgetType: WidgetType): TabTypeEnum {
    switch (widgetType) {
        case WidgetType.Report:
            return TabTypeEnum.Report
        case WidgetType.Chart:
            return TabTypeEnum.Chart;
        case WidgetType.Pivot:
            return TabTypeEnum.Report;
    }
    return null;
}

// Function to get all enum values except specified ones
function getEnumValuesExcept<T>(enumObj: T, valuesToExclude: any[]): (T[keyof T])[] {
    return Object.values(enumObj).filter(value => !valuesToExclude.includes(value)) as (T[keyof T])[];
}

function isMobile() {
    return window.innerWidth <= 960; // Common mobile width threshold (landscape)
    //return /Mobi|Android/i.test(navigator.userAgent);
}
function isTouchDevice() {
    return 'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        (navigator as any).msMaxTouchPoints > 0;
}

function convertTo12HourFormat(time24) {
    if (time24 === null || time24 === undefined || time24 === "") {
        return time24;
    }
    
    let [hours, minutes] = time24.split(':').map(Number);
    let period = hours < 12 ? 'AM' : 'PM';

    hours = hours % 12 || 12; // Converte 0 para 12 e mantém o restante correto

    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
}

function convertTo24HourFormat(time12) {
    if (time12 === null || time12 === undefined || time12 === "") {
        return time12;
    }

    let [time, period] = time12.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (period.toUpperCase() === 'PM' && hours !== 12) {
        hours += 12; // Adiciona 12 horas para PM, exceto 12 PM
    }
    if (period.toUpperCase() === 'AM' && hours === 12) {
        hours = 0; // Converte 12 AM para 00
    }

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

function formatDateTime(inputDateTimeStr: string) {
    if (!inputDateTimeStr) {
        return "";
    }

    //let hoursServerTimeZone = Math.abs(irSettings.hoursServerTimeZone).toString().padStart(2, '0');
    //let sign = irSettings.hoursServerTimeZone < 0 ? '-' : "";
    //let timeZone = `${sign}${hoursServerTimeZone}:00`;
    //const date = new Date(`${inputDateStr}${timeZone}`);
    const date = new Date(`${inputDateTimeStr}`);
    date.setHours(date.getHours() + irSettings.hoursDifferenceTimeZone);

    return DevExpress.localization.formatDate(date, `${irSettings.dateFormat} ${irSettings.displayTimeFormat}`);
}

function formatDate(inputDateTimeStr: string) {
    if (!inputDateTimeStr) {
        return "";
    }

    const date = new Date(`${inputDateTimeStr}`);
    date.setHours(date.getHours() + irSettings.hoursDifferenceTimeZone);

    return DevExpress.localization.formatDate(date, `${irSettings.dateFormat}`);
}

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function computedStyleToInlineStyle(element, options: any = {}) {
    if (!element) {
        throw new Error("No element specified.");
    }

    if (options.recursive) {
        Array.from(element.children).forEach(child => {
            computedStyleToInlineStyle(child, options);
        });
    }

    const computedStyle = getComputedStyle(element);

    const properties = options.properties || Array.from(computedStyle);

    properties.forEach(property => {
        element.style[property] = computedStyle.getPropertyValue(property);
    });
}